import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddCompanyForm from "./AddCompanyForm";
import AddCompanyFormForProposals from "./AddCompanyFormForProposals";


const AddUserModal = ({ isOpen, onConfirm, onCancel, proposalEditor = false, showDownloadDocsModal, getAgency}) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Add New Company</ModalHeader>
      <ModalBody>
        {
          !proposalEditor ?
            <AddCompanyForm /> :
            <AddCompanyFormForProposals
              showDownloadDocsModal={showDownloadDocsModal}
              getAgency={getAgency}
            />
        }
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>Cancel</Button>
        <Button color="primary" onClick={onConfirm}>
          {
            !proposalEditor ? 'Submit' : 'Add new Company'
          }
        </Button>
      </ModalFooter>
    </Modal>
  )
};

export default AddUserModal;
